var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",on:{"touchmove":function($event){$event.preventDefault();}}},[(this.videoData)?_c('CVideo',{ref:"c_video",attrs:{"videoData":this.videoData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }